import { QueryClient } from '@tanstack/react-query';

// 对齐 ops-console 默认(调研§2):retry 1 / 不在窗口聚焦重取 / staleTime 30s。
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
